import { SourceStatusesTableActions } from "./SourceStatusesTableActions";

export const getSourceStatusesTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <SourceStatusesTableActions original={row.original} />,
    },
  ];
};
